import { render, staticRenderFns } from "./announcements.vue?vue&type=template&id=8babb9ec&scoped=true&"
import script from "./announcements.vue?vue&type=script&lang=js&"
export * from "./announcements.vue?vue&type=script&lang=js&"
import style0 from "./announcements.vue?vue&type=style&index=0&id=8babb9ec&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8babb9ec",
  null
  
)

export default component.exports